(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["event-order"] && !Shopify.designMode) return;
  try {
    
function initializeEventQuantities() {
  const form = document.getElementById('EventOrderForm');
  if (!form || form.dataset.quantitiesReady) return;
  const inputs = Array.from(form.querySelectorAll('[data-flavor-quantity]'));
  if (!inputs.length) return;
  form.dataset.quantitiesReady = 'true';
  const error = form.querySelector('#Event-quantity-error');
  const location = form.querySelector('#Event-location');
  const time = form.querySelector('#Event-pickup-time');
  const pickupDate = form.querySelector('#Event-pickup-date');
  const other = form.querySelector('#Event-other-location');
  const choices = Array.from(form.querySelectorAll('[data-fulfillment-choice]'));
  const dates = Array.from(form.querySelectorAll('input[type="date"]'));
  function minimumDate() {
    const parts = new Intl.DateTimeFormat('en-US',{timeZone:'America/New_York',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
    const part = name => parts.find(p => p.type === name).value;
    const d = new Date(Date.UTC(Number(part('year')),Number(part('month'))-1,Number(part('day'))+7));
    return d.toISOString().slice(0,10);
  }
  function validateDates() {
    const min = minimumDate();
    dates.forEach(input => {
      input.min = min;
      let message = !input.disabled && input.value && input.value < min ? error.dataset.dateError : '';
      if (!message && input === pickupDate && !input.disabled && input.value && location.selectedOptions[0]?.dataset.regular && new Date(input.value+'T12:00:00Z').getUTCDay() !== 6) message = error.dataset.saturdayError;
      input.setCustomValidity(message);
    });
  }
  function updatePickup() {
    const active = choices.some(c => c.checked && c.dataset.fulfillmentChoice === 'pickup');
    const option = location.selectedOptions[0];
    const custom = active && location.value === 'Other arrangement';
    form.querySelector('#Event-other-location-panel').hidden = !custom;
    other.disabled = !custom;
    other.required = custom;
    time.readOnly = Boolean(option?.dataset.regular);
    if (option?.dataset.regular) time.value = option.dataset.hours;
    form.querySelector('#Event-pickup-address').textContent = active ? option?.dataset.address || '' : '';
    validateDates();
  }
  function updateFulfillment() {
    const method = choices.find(c => c.checked)?.dataset.fulfillmentChoice;
    form.querySelectorAll('[data-fulfillment-panel]').forEach(panel => {
      const active = panel.dataset.fulfillmentPanel === method;
      panel.hidden = !active;
      panel.querySelectorAll('input, select, textarea').forEach(field => {
        field.disabled = !active;
        field.required = active && field.dataset.requiredFor === method;
        if (!active) field.setCustomValidity('');
      });
    });
    updatePickup();
  }
  function updateQuantities() {
    let total = 0;
    inputs.forEach(input => {
      const q = input.value === '' ? 0 : input.valueAsNumber;
      const valid = Number.isSafeInteger(q) && (q === 0 || q >= 6);
      input.setCustomValidity(valid ? '' : error.dataset.flavorError);
      if (Number.isFinite(q) && q >= 0) total += q;
    });
    form.querySelector('#Event-total').value = String(total);
    form.querySelector('#Event-total-display').value = String(total);
    error.hidden = true;
    return total;
  }
  inputs.forEach(input => input.addEventListener('input',updateQuantities));
  choices.forEach(choice => choice.addEventListener('change',updateFulfillment));
  location.addEventListener('change',() => {time.value='';updatePickup();});
  dates.forEach(input => input.addEventListener('input',validateDates));
  form.addEventListener('submit',event => {
    updateFulfillment();
    const total = updateQuantities();
    if (!form.checkValidity()) {event.preventDefault();form.reportValidity();}
    else if (total < 24) {event.preventDefault();error.textContent=error.dataset.minimumError;error.hidden=false;inputs[0].focus();}
  });
  updateFulfillment();
  updateQuantities();
}
initializeEventQuantities();
document.addEventListener('DOMContentLoaded',initializeEventQuantities);
document.addEventListener('shopify:section:load',initializeEventQuantities);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
